export default {
  path: "price",
  name: "price",
  component: () => import("@/layout/components/commonmenu/index.vue"),
  meta: {
    title: "查价管理-Co-logistics",
    power: "price",
    name: "查价管理"
  },
  children:[
    {
      path: "ocean",
      name: "oceanprice",
      meta: {
        title: "查价管理-Co-logistics",
        power: "seauspricce",
        name: "海派查价"
      },
      component: () => import("@/view/check-price/sea-price/index.vue"),
    },
    {
      path:'usaaircheck',
      name:'usaaircheck',
      meta:{
        title:'空派价格-Co-logistics',
        power: "seepriceusair",
        name: "空派价格"
      },
      component: () => import("@/view/check-price/air-price/usacheck.vue"),
    },
    
    {
      path:'europerailway',
      name:'europerailway',
      meta:{
        title:'欧洲铁派查价-Co-logistics',
        power: "ironeuropeprice",
        name: "欧洲铁派查价"
      },
      component: () => import("@/view/check-price/railway-price/index.vue"),
    },
    {
      path:'oceanship',
      name:'oceanship',
      meta:{
        title:'海运查价-Co-logistics',
        power: "boxprice",
        name: "海运查价"
      },
      component: () => import("@/layout/components/commonmenu/Menu.vue"),
      children:[
        {
          path:'fullcontain',
          name:'fullcontain',
          meta:{
            title:'海运整柜-Co-logistics',
            power: "boxprice",
            name: "海运整柜"
          },
          component: () => import("@/view/check-price/ocean/fullcontain.vue"),
        },
        {
          path:'fulllog',
          name:'fulllog',
          meta:{
            title:'海运审核-Co-logistics',
            power: "seareview",
            name: "海运审核"
          },
          component: () => import("@/view/check-price/ocean/fulllog.vue"),
        }
      ]
    },
    // {
    //   path:'express',
    //   name:'express',
    //   meta:{
    //     title:'快递查价-Co-logistics',
    //     power: "selexpress", //selexpress
    //     name: "快递查价"
    //   },
    //   component: () => import("@/layout/components/commonmenu/Menu.vue"),
    //   children:[
        
    //   ]
    // },
    {
      path:'express',
      name:'express',
      meta:{
        title:'快递查价-Co-logistics',
        power: "selexpress",
        name: "快递查价"
      },
      component: () => import("@/view/check-price/express/index.vue"),
    },
    {
      path:'other',
      name:'other',
      meta:{
        title:'其它单询-Co-logistics',
        power: "single_price_air",
        name: "其它单询"
      },
      component: () => import("@/view/check-price/air-price/other.vue"),
    },
    {
      path:'checktable',
      name:'checktable',
      meta:{
        title:'海派价格表-Co-logistics',
        power: "price_excel",
        name: "海派价格表"
      },
      component: () => import("@/view/check-price/priceTable/index.vue"),
    },
    {
      path:'excel',
      name:'excel',
      meta:{
        noShow: true,
        title:'预览-Co-logistics',
        power: "price_excel",
        name: "excel"
      },
      component: () => import("@/view/check-price/priceTable/components/excel.vue"),
    },
    {
      path:'exrecord',
      name:'exrecord',
      meta:{
        title:'报价记录-Co-logistics',
        power: "price_excel",
        name: "报价记录"
      },
      component: () => import("@/view/check-price/exportRecord/index.vue"),
    },
    {
      path:'salefbacode',
      name:'salefbacode',
      meta:{
        name: "亚马逊仓库地址管理",
        power: "fbacode",
        title:'亚马逊地址管理-Co-logistics'
      },
      component: () => import("@/view/business/fbacode.vue"),
    },
  ]
}